interface ClassNames {
  [className: string]: string;
}

interface Modifier {
  [key: string]: string | boolean | string[];
}

export function getBem(blocks: ClassNames | ClassNames[]) {
  const bem = (element?: string | Modifier, modifier?: Modifier) => {
    // Force block to be a array
    if (!Array.isArray(blocks)) {
      blocks = [blocks];
    }

    // Remove null and undefined elements
    blocks = blocks.filter(Boolean);

    // Shift the arguments, if we dont have an element but modifier
    if (typeof element === 'object') {
      modifier = element;
      element = undefined;
    }

    let classes = [];
    for (const block of blocks) {
      const modifierClasses = generateFromModule(block, element, modifier);

      if (modifierClasses) {
        classes.push(...modifierClasses);
      }
    }

    classes = classes.filter(Boolean);

    if (classes.length === 0) {
      return '';
    }

    return classes.join(' ');
  };

  return bem;
}

function generateFromModule(
  block: ClassNames,
  element?: string,
  modifier?: Modifier,
) {
  const baseClass = element ?? 'scope';
  const modifierClasses = generateModifier(baseClass, modifier);
  const classes = [baseClass, ...modifierClasses];

  return classes.map((className) => block[className]);
}

function generateModifier(baseClass: string, modifier?: Modifier) {
  if (!modifier) {
    return [];
  }
  const classes = [];

  for (const key of Object.keys(modifier)) {
    const modifierValue = modifier?.[key];

    if (!modifierValue) {
      continue;
    }

    if (typeof modifierValue === 'boolean') {
      if (modifierValue) {
        classes.push(`${baseClass}--${key}`);
      }
    } else if (Array.isArray(modifierValue)) {
      for (const modifier of modifierValue) {
        classes.push(`${baseClass}--${key}-${modifier}`);
      }
    } else {
      classes.push(`${baseClass}--${key}-${modifierValue}`);
    }
  }

  return classes;
}
